export default {
  tasks: [],
  stats_leads: [],
  stats_opportunities: [],
  stats_sales: [],
  invitations: [],
  members: [],
  current_team: null,
  subscription: null,
};
